import script from "./UsersView.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsersView.vue?vue&type=script&lang=ts&setup=true"

import "./UsersView.vue?vue&type=style&index=0&id=21a17474&lang=scss"

const __exports__ = script;

export default __exports__